module.exports = __webpack_public_path__ + "static/media/settle_orange.d8233657.svg";